var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWienwappen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 99,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#ffffff",
    id: "path7371",
    d: "m3.46823,2.84003c0,1.34998 0.05625,2.5675 0.1875,3.65625c0.06375,0.53001 0.16,1.02875 0.25,1.5c0.7025,3.68498 2.10375,5.59 3.3125,6.15625c0.26375,0.12375 0.51625,0.1875 0.75,0.1875c0.24,0.00003 0.48625,-0.06375 0.75,-0.1875c1.20375,-0.56625 2.63988,-2.47125 3.34375,-6.15625c0.08875,-0.47127 0.155,-0.97 0.21875,-1.5c0.13125,-1.08874 0.21875,-2.30625 0.21875,-3.65625l-9.03125,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#eb0c0d",
    id: "path7754",
    d: "m0.10824,0.15807c0,11.77646 0.49069,22.39742 1.63564,31.89506l31.07724,0l0,-31.89506l-32.71288,0zm45.79803,0l0,31.89506l31.07724,0c1.14495,-9.49755 1.90825,-20.11842 1.90825,-31.89506l-32.98549,0zm-41.98153,44.98021c6.12821,32.14568 18.35193,48.764 28.89638,53.70364l0,-53.70364l-28.89638,0zm41.98153,0l0,53.70364c10.50083,-4.93964 23.02769,-21.55779 29.16898,-53.70364l-29.16898,0z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWienwappen);
export default __webpack_public_path__ + "static/media/wienwappen.5a2910af2978b8c528c3bf2ac76ecc83.svg";
export { ForwardRef as ReactComponent };